import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import React, {useEffect, useRef} from 'react'

import styles from './EditSettingsForm.css'

import IconButton from 'src/components/common/IconButton/IconButton'

type Props = {
  className?: string
  children: React.ReactNode
  inline?: boolean
  loader?: boolean
  disabled?: boolean
  scrollIntoView?: boolean
  onConfirmClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onCancelClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onDeleteClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onBlur?: () => void
}

function EditSettingsForm({
  children,
  inline,
  className,
  loader,
  disabled,
  onBlur,
  onConfirmClick,
  onCancelClick,
  onDeleteClick,
  scrollIntoView = true,
}: Props) {
  const formRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (
      scrollIntoView &&
      formRef.current &&
      formRef.current.getBoundingClientRect().bottom > window.innerHeight
    ) {
      formRef.current?.scrollIntoView({behavior: 'smooth'})
    }
  }, [scrollIntoView])

  return (
    <div
      ref={formRef}
      className={classNames(styles.editSettingsForm, className, {
        [styles.inline]: inline,
      })}
      onBlur={e => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          onBlur?.()
        }
      }}
    >
      <div className={styles.settings}>{children}</div>
      <div className={styles.actions}>
        <Button text onClick={onConfirmClick} loader={loader} disabled={disabled}>
          {'Done'}
        </Button>
        {inline ? (
          <IconButton title={'Cancel'} icon={'close'} onClick={onCancelClick} />
        ) : (
          <Button className={styles.cancelButton} text onClick={onCancelClick}>
            {'Cancel'}
          </Button>
        )}
        {onDeleteClick && (
          <IconButton
            className={styles.deleteButton}
            icon={'trash'}
            title={'Delete'}
            aria-label={'Delete'}
            onClick={onDeleteClick}
          />
        )}
      </div>
    </div>
  )
}

export default EditSettingsForm
